export default __webpack_public_path__ + "static/1p_2-f3e73244b32d6601bf69ff10ea4d93dd.jpg";